var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Inject, Provide } from 'vue-property-decorator';
import { INJECT_UICORE_AICONTEXT } from "../../../../lib/utils/consts";
let ExprInputAIProvider = class ExprInputAIProvider extends Vue {
  get getAiContext() {
    if (!this.uicoreAiContext) return undefined;
    return () => {
      const ctx = {
        ...this.uicoreAiContext()
      };
      if (this.field) {
        ctx.field = this.field;
      }
      if (this.eventArg) {
        ctx.eventArg = this.eventArg;
      }
      return ctx;
    };
  }
  render() {
    const h = arguments[0];
    return h("div", [" ", this.$slots.default]);
  }
};
__decorate([Inject({
  from: INJECT_UICORE_AICONTEXT,
  default: null
})], ExprInputAIProvider.prototype, "uicoreAiContext", void 0);
__decorate([Prop()], ExprInputAIProvider.prototype, "field", void 0);
__decorate([Prop()], ExprInputAIProvider.prototype, "eventArg", void 0);
__decorate([Provide(INJECT_UICORE_AICONTEXT)], ExprInputAIProvider.prototype, "getAiContext", null);
ExprInputAIProvider = __decorate([Component({
  name: 'ExprInputAIProvider'
})], ExprInputAIProvider);
export default ExprInputAIProvider;
//# sourceMappingURL=ExprInputAiProvider.js.map
